import { LocationRegionField } from '../../dashboards/primitives/LocationRegionField';

import ClientAddressFields from './ClientAddressFields';
import LocationModeToggle from './LocationModeToggle';
import { COLUMN, NOTE } from './step-layout';
import TimeZoneConfirmation from './TimeZoneConfirmation';
import VenueSelectField from './VenueSelectField';
import type { WhenWhatFormApi } from './when-what-form-api';
import WorkshopTypeDateTimeFields from './WorkshopTypeDateTimeFields';

/**
 * Step 1: region first, then what kind of place the event is at, then the
 * workshop type, date and time.
 */
export default function WhenWhereStep({ form }: { form: WhenWhatFormApi }) {
  const { fields, regions, regionsLoading, regionsFailed, setRegion, fieldError } = form;
  const { locationMode } = fields;
  return (
    <div style={COLUMN}>
      <LocationRegionField
        mode="open"
        regions={regions}
        loading={regionsLoading}
        failed={regionsFailed}
        value={fields.regionId}
        label=""
        error={fieldError('regionId')}
        onChange={setRegion}
      />
      <LocationModeToggle form={form} />
      {locationMode === 'venue' && <VenueSelectField form={form} />}
      {locationMode === 'client-site' && <ClientAddressFields form={form} />}
      <WorkshopTypeDateTimeFields form={form} />
      {locationMode !== 'venue' && <TimeZoneConfirmation form={form} />}
      <p style={NOTE}>
        {locationMode === 'venue'
          ? 'Times are the venue’s local clock.'
          : 'Times are the event’s local clock.'}
      </p>
    </div>
  );
}
